<template>
	<header :class="{ overlay }">
		<h1>Young Voice</h1>
		<div class="logo">
			<img src="images/eu-logo.svg" alt="logo-eu" />
			<img src="images/logo-yv.svg" class="logo-jv" alt="logo-yv" />
			<img src="images/njr-logo-liggend.svg" class="logo-njr" alt="logo-njr" />
		</div>
	</header>
</template>

<script>
export default {
	data: () => ({
		overlay: false
	}),

	watch: {
		$route() {
			this.overlay = this.$route.name === 'Results' ? true : false
		}
	}
}
</script>

<style lang="scss" scoped>
header {
	top: 0;
	width: 100%;
	z-index: 1;
	position: fixed;
	display: flex;
	justify-content: center;
	padding-top: 20px;

	&.overlay {
		z-index: 2;
		background: linear-gradient(0deg, rgba(3, 74, 188, 0) 0%, rgba(3, 74, 188, 1) 80%);
		height: 200px;
		pointer-events: none;
	}
}

img {
	width: 90px;
	height: auto;

	@include media('<=phone') {
		height: 65px;
	}
}

h1 {
	opacity: 0;
	pointer-events: none;
	position: absolute;
}

.logo
{
	width: 100%;
	max-width: 580px;
	display: flex;
	align-items: top;
	justify-content: space-between;

	@include media('<=tablet') 
	{
		padding: 0 20px;
		max-width: 420px;
	}
	
	.logo-eu 
	{
		height: 75px;
		@include media('<=phone')
		{
			height: 70px;
			width: 85px;
		}
	}
	.logo-jv
	{
		height: 90px;
    	width: 100px;
		@include media('<=phone')
		{
			height: 70px;
			width: 85px;
		}
	}
	.logo-njr 
	{
		width: 103px;
    	height: 81px;
		@include media('<=phone') {width: 85px}
	}
}
</style>
